import { label } from "framer-motion/client";

export const FACULTY_DEFAULT_SCHEMA = {
  sections: [
    {
      id: "personalInfo",
      title: "Personal Information",
      removable: false,
      fields: [
        { id: "department", label: "Department", type: "text", required: true, editable: true },
        { id: "postName", label: "Post Name", type: "text", required: true, editable: true },
        { id: "categoryOfPost", label: "Category of Post", type: "select", required: true, options: ["UR", "OBC", "SC", "ST", "EWS"], editable: true },

        { id: "name", label: "Full Name", type: "text", required: true, validations: { minLength: 2, maxLength: 100 }, editable: true },
        { id: "motherName", label: "Mother's Name", type: "text", required: true, editable: true },
        { id: "fatherName", label: "Father's Name", type: "text", required: true, editable: true },
        { id: "dateOfBirth", label: "Date of Birth", type: "date", required: true, editable: true },
        { id: "gender", label: "Gender", type: "select", required: true, options: ["MALE", "FEMALE", "OTHER"], editable: true },
        { id: "candidateType", label: "Candidate Type", type: "select", required: true, options: ["MEDICAL", "NON-MEDICAL"], editable: true },
        { id: "categoryOfCandidate", label: "Category of Candidate", type: "select", required: true, options: ["UR", "OBC", "SC", "ST", "EWS"], editable: true },
        { id: "religion", label: "Religion", type: "text", required: true, editable: true },
        { id: "nationality", label: "Nationality", type: "text", required: true, editable: true },
        { id: "idNumber", label: "Aadhar Number/ Any Valid ID Number", type: "text", required: true, editable: true },
        { id: "maritalStatus", label: "Marital Status", type: "select", required: true, options: ["MARRIED", "UNMARRIED", "DIVORCED", "WIDOWED"], editable: true },
        { id: "isPWD", label: "Is Persons with Benchmark Disability (PwBD)?", type: "checkbox", required: false, editable: true },
        { id: "pwdPercentage", label: "PwBD Percentage", type: "number", required: false, validations: { min: 0, max: 100 }, editable: true },
        { id: "exServiceMan", label: "Ex-ServiceMan", type: "checkbox", required: false, editable: true },
        { id: "ageRelaxationRequired", label: "Age Relaxation Required?", type: "checkbox", required: false, editable: true },
        { id: "isGovernmentServant", label: "Are you a Govt employee?", type: "checkbox", required: false, editable: true },
        { id: "natureOfEmployment", label: "Nature of Employment", type: "text", required: false, editable: true },
        { id: "nocFromEmployment", label: "NOC obtained from current employer?", type: "checkbox", required: false, editable: true },
        { id: "mobile", label: "Mobile Number", type: "phone", required: true, validations: { regex: "^[6-9]\\d{9}$" }, editable: true },
        { id: "email", label: "Email Address", type: "email", required: true, editable: true },
        { id: "alternateEmail", label: "Alternate Email Address", type: "email", required: false, editable: true },
        { id: "sameAddress", label: "Permanent Address is same as Current Address?", type: "checkbox", required: false, editable: true },
        { id: "currentAddress", label: "Current Address", type: "address", required: true, editable: true },
        { id: "permanentAddress", label: "Permanent Address", type: "address", required: true, editable: true }
      ]
    },
    {
      id: "qualifications",
      title: "Educational Qualifications",
      removable: false,
      fields: [
        {
          id: "qualificationsList",
          label: "Qualifications",
          type: "repeater",
          required: true,
          fields: [
            { id: "type", label: "Qualification Type", type: "select", required: true, options: ["10TH/MATRIC/SSC/EQUIVALENT", "12TH/INTERMEDIATE/HSC/EQUIVALENT", "UNDERGRADUATE QUALIFICATION", "POSTGRADUATE QUALIFICATION", "PHD", "SUPER SPECIALITY", "DIPLOMA", "CERTIFICATE", "FELLOWSHIP", "OTHER"] },
            { id: "degree", label: "Degree Name", type: "text", required: false },
            { id: "institution", label: "Institution/College", type: "text", required: true },
            { id: "board", label: "Board/University", type: "text", required: true },
            { id: "passingYear", label: "Passing Year", type: "number", required: true },
            { id: "percentage", label: "Percentage/GPA", type: "text", required: true },
            { id: "specializationArea", label: "Specialization/Subject", type: "text", required: false }
          ]
        }
      ]
    },
    {
      id: "councilRegistration",
      title: "Council Registration",
      removable: true,
      fields: [
        { id: "registeredWith", label: "Registered Council Name", type: "text", required: false, editable: true },
        { id: "registrationNumber", label: "Registration Number", type: "text", required: false, editable: true },
        { id: "registrationDate", label: "Registration Date", type: "date", required: false, editable: true },
        { id: "renewalDate", label: "Renewal Date", type: "date", required: false, editable: true }
      ]
    },
    {
      id: "experience",
      title: "Work Experience",
      removable: false,
      fields: [
        {
          id: "experienceList",
          label: "Work Experience List",
          type: "repeater",
          required: false,
          fields: [
            { id: "organizationName", label: "Organization Name", type: "text", required: true },
            { id: "designation", label: "Designation", type: "text", required: true },
            { id: "serviceFrom", label: "Service From Date", type: "date", required: true },
            { id: "serviceTo", label: "Service To Date", type: "date", required: false },
            { id: "isCurrent", label: "Is Current Organization?", type: "checkbox", required: false },
            { id: "payScale", label: "Pay Scale / Salary", type: "text", required: false }
          ]
        }
      ]
    },
    {
      id: "professional",
      title: "Professional & Publication Details",
      removable: true,
      fields: [
        { id: "pubNational", label: "National Indexed Publications", type: "number", required: false, defaultValue: 0, editable: true },
        { id: "pubInternational", label: "International Indexed Publications", type: "number", required: false, defaultValue: 0, editable: true },
        {
          id: "researchProjects",
          label: "Research Projects",
          type: "repeater",
          required: false,
          fields: [
            { id: "title", label: "Project Title", type: "text", required: true },
            { id: "role", label: "Role (e.g., Principal Investigator)", type: "text", required: true },
            { id: "fundingAgency", label: "Funding Agency", type: "text", required: true },
            { id: "duration", label: "Duration", type: "text", required: true }
          ]
        },
        {
          id: "memberships",
          label: "Professional Memberships",
          type: "repeater",
          required: false,
          fields: [
            { id: "organizationName", label: "Organization Name", type: "text", required: true },
            { id: "membershipId", label: "Membership ID", type: "text", required: true },
            { id: "validFrom", label: "Valid From Date", type: "date", required: true },
            { id: "validTo", label: "Valid To Date", type: "date", required: false }
          ]
        },
        { id: "awards", label: "Awards (Comma separated list)", type: "textarea", required: false, editable: true },
        { id: "editorialBoards", label: "Editorial Boards (Comma separated list)", type: "textarea", required: false, editable: true }
      ]
    },
    {
      id: "documents",
      title: "Upload Documents",
      removable: false,
      fields: [
        { id: "photo", label: "Passport Photograph", type: "image", required: true, editable: true },
        { id: "signature", label: "Signature Scan", type: "image", required: true, editable: true },
        { id: "allCert", label: "All Merged Certificates (PDF)", type: "file", required: true, editable: true },
        { id: "paymentCert", label: "Payment Receipt Screenshot/PDF", type: "file", required: true, editable: true },
        { id: "nocCert", label: "NOC from Employer (PDF)", type: "file", required: false, editable: true },
        { id: "publicationsPdf", label: "Publications PDF File", type: "file", required: false, editable: true }
      ]
    }
  ]
};

export const NON_FACULTY_DEFAULT_SCHEMA = {
  sections: [
    {
      id: "personalInfo",
      title: "Personal Information",
      removable: false,
      fields: [
        { id: "department", label: "Department", type: "text", required: true, editable: true },
        { id: "postName", label: "Post Name", type: "text", required: true, editable: true },
        { id: "categoryOfPost", label: "Category of Post", type: "select", required: true, options: ["UR", "OBC", "SC", "ST", "EWS"], editable: true },
        { id: "name", label: "Full Name", type: "text", required: true, validations: { minLength: 2, maxLength: 100 }, editable: true },
        { id: "motherName", label: "Mother's Name", type: "text", required: true, editable: true },
        { id: "fatherName", label: "Father's Name", type: "text", required: true, editable: true },
        { id: "dateOfBirth", label: "Date of Birth", type: "date", required: true, editable: true },
        { id: "gender", label: "Gender", type: "select", required: true, options: ["MALE", "FEMALE", "OTHER"], editable: true },

        { id: "candidateType", label: "Candidate Type", type: "select", required: true, options: ["MEDICAL", "NON-MEDICAL", "ANY"], editable: true },
        { id: "categoryOfCandidate", label: "Category of Candidate", type: "select", required: true, options: ["UR", "OBC", "SC", "ST", "EWS"], editable: true },
        { id: "religion", label: "Religion", type: "text", required: true, editable: true },
        { id: "nationality", label: "Nationality", type: "text", required: true, editable: true },
        { id: "idNumber", label: "Aadhar Number/ Any Valid ID Number", type: "text", required: true, editable: true },
        { id: "maritalStatus", label: "Marital Status", type: "select", required: true, options: ["MARRIED", "UNMARRIED", "DIVORCED", "WIDOWED"], editable: true },
        { id: "isPWD", label: "Is Persons with Benchmark Disability (PwBD)?", type: "checkbox", required: false, editable: true },
        { id: "pwdPercentage", label: "PwBD Percentage", type: "number", required: false, validations: { min: 0, max: 100 }, editable: true },
        { id: "exServiceMan", label: "Ex-ServiceMan", type: "checkbox", required: false, editable: true },
        { id: "ageRelaxationRequired", label: "Age Relaxation Required?", type: "checkbox", required: false, editable: true },
        { id: "isGovernmentServant", label: "Are you a Govt employee?", type: "checkbox", required: false, editable: true },
        { id: "natureOfEmployment", label: "Nature of Employment", type: "text", required: false, editable: true },
        { id: "nocFromEmployment", label: "NOC obtained from current employer?", type: "checkbox", required: false, editable: true },
        { id: "mobile", label: "Mobile Number", type: "phone", required: true, validations: { regex: "^[6-9]\\d{9}$" }, editable: true },
        { id: "email", label: "Email Address", type: "email", required: true, editable: true },
        { id: "alternateEmail", label: "Alternate Email Address", type: "email", required: false, editable: true },
        { id: "sameAddress", label: "Permanent Address is same as Current Address?", type: "checkbox", required: false, editable: true },
        { id: "currentAddress", label: "Current Address", type: "address", required: true, editable: true },
        { id: "permanentAddress", label: "Permanent Address", type: "address", required: true, editable: true }
      ]
    },
    {
      id: "qualifications",
      title: "Educational Qualifications",
      removable: false,
      fields: [
        {
          id: "qualificationsList",
          label: "Qualifications",
          type: "repeater",
          required: true,
          fields: [
            { id: "type", label: "Qualification Type", type: "select", required: true, options: ["10TH/MATRIC/SSC/EQUIVALENT", "12TH/INTERMEDIATE/HSC/EQUIVALENT", "UNDERGRADUATE QUALIFICATION", "POSTGRADUATE QUALIFICATION", "PHD", "DIPLOMA", "CERTIFICATE", "OTHER"] },
            { id: "degree", label: "Degree Name", type: "text", required: false },
            { id: "institution", label: "Institution/College", type: "text", required: true },
            { id: "board", label: "Board/University", type: "text", required: true },
            { id: "passingYear", label: "Passing Year", type: "number", required: true },
            { id: "percentage", label: "Percentage/GPA", type: "text", required: true },
            { id: "specializationArea", label: "Specialization/Subject", type: "text", required: false }
          ]
        }
      ]
    },
    {
      id: "experience",
      title: "Work Experience",
      removable: false,
      fields: [
        {
          id: "experienceList",
          label: "Work Experience List",
          type: "repeater",
          required: false,
          fields: [
            { id: "organizationName", label: "Organization Name", type: "text", required: true },
            { id: "designation", label: "Designation", type: "text", required: true },
            { id: "serviceFrom", label: "Service From Date", type: "date", required: true },
            { id: "serviceTo", label: "Service To Date", type: "date", required: false },
            { id: "isCurrent", label: "Is Current Organization?", type: "checkbox", required: false },
            { id: "payScale", label: "Pay Scale / Salary", type: "text", required: false }
          ]
        }
      ]
    },
    {
      id: "documents",
      title: "Upload Documents",
      removable: false,
      fields: [
        { id: "photo", label: "Passport Photograph", type: "image", required: true, editable: true },
        { id: "signature", label: "Signature Scan", type: "image", required: true, editable: true },
        { id: "allCert", label: "All Merged Certificates (PDF)", type: "file", required: true, editable: true },
        { id: "paymentCert", label: "Payment Receipt Screenshot/PDF", type: "file", required: true, editable: true }
      ]
    }
  ]
};

export const CORE_PERSONAL_FIELDS = [
  "name",
  "dateOfBirth",
  "gender",
  "mobile",
  "email",
  "categoryOfCandidate",
  "currentAddress",
  "permanentAddress",
];

export const CORE_DOCUMENT_FIELDS = ["photo", "signature"];

export const isCoreField = (fieldId: string): boolean => {
  return CORE_PERSONAL_FIELDS.includes(fieldId) || CORE_DOCUMENT_FIELDS.includes(fieldId);
};

export const ALLIED_DEFAULT_SCHEMA = {
  sections: [
    {
      id: "personalInfo",
      title: "Personal Information",
      removable: false,
      fields: [
        { id: "name", label: "Full Name", type: "text", required: true, validations: { minLength: 2, maxLength: 100 }, editable: true },
        { id: "dateOfBirth", label: "Date of Birth", type: "date", required: true, editable: true },
        { id: "gender", label: "Gender", type: "select", required: true, options: ["Male", "Female", "Transgender"], editable: true },
        { id: "categoryOfCandidate", label: "Category of Candidate", type: "select", required: true, options: ["UR", "OBC", "SC", "ST", "EWS"], editable: true },
        { id: "fathersName", label: "Father's Name", type: "text", required: true, editable: true },
        { id: "email", label: "Email Address", type: "email", required: true, editable: true },
        { id: "mobile", label: "Mobile Number", type: "phone", required: true, validations: { regex: "^[6-9]\\d{9}$" }, editable: true },
        { id: "alternateMobile", label: "Alternate Mobile Number", type: "phone", required: false, validations: { regex: "^[6-9]\\d{9}$" }, editable: true },
        { id: "physicalIdentification", label: "Physical Identification Mark", type: "text", required: true, editable: true },
        { id: "isPWD", label: "Are you a Person with Disability (PwD)?", type: "checkbox", required: false, editable: true },
        { id: "pwdPercentage", label: "PwD Percentage", type: "number", required: false, validations: { min: 0, max: 100 }, editable: true },
        { id: "sameAddress", label: "Permanent Address is same as Current Address?", type: "checkbox", required: false, editable: true },
        { id: "currentAddress", label: "Current Address", type: "address", required: true, editable: true },
        { id: "permanentAddress", label: "Permanent Address", type: "address", required: true, editable: true }
      ]
    },
    {
      id: "neetDetails",
      title: "NEET Details",
      removable: true,
      fields: [
        { id: "neetRoll", label: "NEET Roll Number", type: "text", required: true, editable: true },
        { id: "neetAIRank", label: "NEET All India Rank", type: "number", required: true, editable: true },
        { id: "neetCategoryRank", label: "NEET Category Rank", type: "number", required: false, editable: true }
      ]
    },
    {
      id: "education",
      title: "Educational Details (12th Standard)",
      removable: false,
      fields: [
        { id: "board", label: "Board Name", type: "text", required: true, editable: true },
        { id: "passingYear", label: "Passing Year", type: "number", required: true, validations: { min: 1980, max: 2026 }, editable: true },
        { id: "school", label: "School Name", type: "text", required: true, editable: true },
        { id: "schoolState", label: "School State", type: "text", required: true, editable: true },
        { id: "obtainedMarks", label: "Obtained Marks", type: "number", required: true, editable: true },
        { id: "totalMarks", label: "Total Marks", type: "number", required: true, editable: true },
        { id: "percentage", label: "Percentage (%)", type: "number", required: true, editable: false },
        { id: "physics", label: "Passed Physics?", type: "checkbox", required: false, editable: true },
        { id: "chemistry", label: "Passed Chemistry?", type: "checkbox", required: false, editable: true },
        { id: "biology", label: "Passed Biology?", type: "checkbox", required: false, editable: true },
        { id: "english", label: "Passed English?", type: "checkbox", required: false, editable: true }
      ]
    },
    {
      id: "documents",
      title: "Upload Documents",
      removable: false,
      fields: [
        { id: "photo", label: "Passport size Photograph", type: "image", required: true, editable: true },
        { id: "signature", label: "Signature Scan", type: "image", required: true, editable: true },
        { id: "aadhar", label: "Aadhar Card (PDF/Image)", type: "file", required: true, editable: true },
        { id: "scoreCard", label: "NEET Score Card (PDF/Image)", type: "file", required: true, editable: true },
        { id: "marksheet12", label: "12th Marksheet (PDF/Image)", type: "file", required: true, editable: true },
        { id: "dobCert", label: "DOB Certificate (10th PDF/Image)", type: "file", required: true, editable: true },
        { id: "categoryCert", label: "Category Certificate (PDF/Image)", type: "file", required: false, editable: true },
        { id: "pwdCert", label: "PwD Certificate (PDF/Image)", type: "file", required: false, editable: true },
        { id: "paymentCert", label: "Payment Receipt Screenshot/PDF", type: "file", required: true, editable: true }
      ]
    }
  ]
};

